// src/components/Button.js
export default function Button({ children, className = "", ...props }) {
  return (
    <button
      {...props}
      className={`px-4 py-2 rounded-xl font-medium transition-colors ${className}`}
    >
      {children}
    </button>
  );
}
